// internal
import { TypeAssert } from '@creejs/commons-lang'

// owned
import ProviderType from '../provider-type.js'
import Provider from '../provider.js'
import Log4jsFactory from './log4js-factory.js'

const { assertNotNil } = TypeAssert

export default class Log4jsProvider extends Provider {
  /**
   * Gets the provider type (Log4js).
   * @returns {string} "LOG4JS"
   * @override
   */
  getType () {
    return ProviderType.Log4js
  }

  /**
   * Creates a new Provider instance.
   * @param {*} libraryModule - The library module to be used.
   * @param {*} setting - Configuration settings for the provider.
   * @returns {Log4jsFactory} A new instance of Log4jsFactory.
   * @override
   */
  createLogFactory (libraryModule, setting) {
    assertNotNil(libraryModule)
    const factory = new Log4jsFactory(libraryModule, setting)
    factory.init()
    return factory
  }
}
